import * as css from './close-button.scss';
import close from '../../assets/icons/close.png';
import { createElement } from '../../utils/utils';
import { BaseProps } from '../../types';
import { translate } from '../../services/i18n/i18n';

export interface Props extends BaseProps {
  onClick(): void;
  invert: boolean;
  alt?: string;
}

export const CloseButton = (props: Props) => {
  const { onClick, invert, dataHook, alt, ariaLabel } = props;
  const themeClass = invert ? css.dark : '';
  const image = createElement<HTMLImageElement>({
    tagName: 'img',
    alt: ariaLabel || translate('close.button.label'),
    dataHook,
    className: `${css.closeButtonImage} ${themeClass}`,
  });
  if (alt) {
    image.alt = alt;
  }
  image.src = close;
  const button = createElement<HTMLButtonElement>({
    tagName: 'button',
    className: `${css.closeButton}`,
    ariaLabel: ariaLabel || translate('close.button.label'),
  });
  button.onclick = onClick;
  button.appendChild(image);
  return button;
};
